<template>
  <div class="persona-grid-content" id="identidade-verbal-persona-grid" data-search-anchor>
    <div class="persona-grid-container" :style="{ backgroundImage: `url(${personaImageSrc})` }"></div>
    <div class="persona-grid-container" :style="{ backgroundImage: `url(${personaImageSrc2})` }"></div>
    <div class="persona-grid-container" :style="{ backgroundImage: `url(${personaImageSrc3})` }"></div>            
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonaPageMixin from '@/mixins/persona-page-mixin'
import { PersonaPageStore } from '@/store/verbal-identity-page/persona-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonaGridSection extends Mixins(PersonaPageMixin) {
  personaPageStore: PageStoreContract = getModule(PersonaPageStore, this.$store)

  get personaImageSrc(): string {
    return this.getElementMedia(3, 0)
  }

  get personaImageSrc2(): string {
    return this.getElementMedia(3, 1)
  }

  get personaImageSrc3(): string {
    return this.getElementMedia(3, 2)
  }

  async getPersonaPage(): Promise<void> {
    await this.personaPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personaPageStore.isLoading) {
      await this.getPersonaPage()
    }
  }
}
</script>

<style lang="scss">
.persona-grid-content {   
  display: flex; 
  justify-content: center; 
  gap: 24px; 
  margin: 95px auto 112px;
  max-width: 1032px;
}

.persona-grid-container {
  width: 333px;
  height: 712px;
  background-size: cover; 
  background-position: center;   
}

</style>
